import {ApiUserRepository} from '@infra/domain/model/User/ApiUserRepository';

import {GetUserOverallInfo} from './GetUserOverallInfo';

const UserApplication = {
  getUserOverallInfo: GetUserOverallInfo(ApiUserRepository),
};

export {UserApplication};
